import Vue from 'vue'
import Vuex from 'vuex'
import { store } from '../app'
import _ from 'lodash'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const initialStoreModules = _.cloneDeep(store)

export default new Vuex.Store({
  mutations: {
    RESETSTATE (state, payload) {
      _.forOwn(initialStoreModules, (value, key) => {
        state[key] = _.cloneDeep(value.state)
      })
    }
  },
  modules: store,
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js